import Modal from 'components/Modal';
import Text from 'components/Text';
import cashierActions from 'features/cashier/services/actions';
import cashierSelectors from 'features/cashier/services/selectors';
import { useSocketContext } from 'hooks/useSocket';
import React from 'react';
import { useSetLoadingPage } from 'services/UI/LoadingPage';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
type Props = {
  component?: boolean;
  visible?: boolean;
  onClose?: () => void;
  onCancel?: () => void;
  onSubmit?: () => void;
};
function ModalWarningConsentForm({ component, onClose, visible: visibleProp, onSubmit, onCancel }: Props) {
  const setLoading = useSetLoadingPage();
  const customer = cashierSelectors.getSelectedCustomer();
  const socketContext = useSocketContext();
  const dispatch = useAppDispatch();
  const visible = cashierSelectors.getVisibleModalWarningConsentForm();
  const handleClose = () => {
    if (component) return onClose?.();
    if (component) return onCancel?.();
    dispatch(cashierActions.setVisibleModalWarningConsentForm(false));
  };

  const handleSubmit = () => {
    if (component) return onSubmit?.();

    if (!customer?.customerId) return;
    setLoading(true);
    socketContext.sendConsentForm(customer?.customerId);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  return (
    <>
      <Modal
        visible={component ? visibleProp : visible}
        onClose={handleClose}
        hiddenHeader
        okTitle={'Yes'}
        onSubmit={handleSubmit}
        cancelTitle='No'
        v2
        containerPadding={0}
        noneBodyStyle
        width={700}
      >
        <ModalStyled>
          <IconWarningBig />
          <Text variant='H7' mt={1} mb={1} >
            Please sign the form to proceed with the selected services
          </Text>
        </ModalStyled>
      </Modal>
    </>
  );
}

export default ModalWarningConsentForm;


const ModalStyled = styled.div`
  text-align: center;
  padding-top: 16px;
`;

const IconWarningBig = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="101" height="101" viewBox="0 0 101 101" fill="none">
    <path d="M48.6099 12.4707C52.2837 11.6914 56.2525 13.4942 58.1802 16.6934C68.7896 35.2403 79.4107 53.7813 90.0279 72.3243C90.7544 73.6368 91.6275 74.8965 92.022 76.3653C92.7173 78.6582 92.5259 81.209 91.4224 83.3438C89.9576 86.3145 86.8013 88.418 83.4634 88.4239C61.5181 88.4278 39.5709 88.4239 17.6255 88.4278C15.1294 88.4336 12.5982 87.4864 10.8306 85.7032C9.14507 84.0215 8.15874 81.6719 8.11187 79.295C8.05132 77.4122 8.61382 75.5547 9.50249 73.9102C20.4009 54.9219 31.2837 35.9258 42.1373 16.9141C42.5728 16.0157 43.3384 15.3555 44.0728 14.709C45.356 13.584 46.94 12.8125 48.6099 12.4707ZM49.3033 17.2305C48.1334 17.5801 46.9693 18.2286 46.2369 19.2266C35.5943 37.8184 24.9595 56.418 14.3169 75.0118C13.7505 76.0118 13.0865 76.9922 12.8755 78.1446C12.4459 79.8516 13.0923 81.7754 14.4986 82.8438C15.6959 83.8145 17.3209 83.92 18.8013 83.8965C40.2876 83.8946 61.774 83.8946 83.2603 83.8965C84.8365 83.9121 86.315 82.9219 87.0748 81.5684C87.94 80.0879 87.8716 78.1719 87.0591 76.6856C76.0201 57.3868 64.9439 38.1055 53.9205 18.8008C52.8209 17.4922 50.9869 16.7618 49.3033 17.2305Z" fill="#FF7D00" />
    <path d="M46.0768 36.0348C47.8873 33.8453 51.4518 33.5152 53.6998 35.2106C54.8463 36.0191 55.651 37.2906 55.9127 38.6676C56.1725 39.9039 56.0162 41.1774 55.8502 42.4156C55.1666 46.7613 53.9791 51.0035 53.0729 55.3024C52.5455 57.8492 52.2877 60.4371 52.1022 63.027C50.9127 63.0582 49.7252 63.1109 48.5358 63.0856C48.2701 55.5758 45.4186 48.4606 44.7193 41.0055C44.5592 39.2672 44.9068 37.3863 46.0768 36.0348Z" fill="#FF7D00" />
    <path d="M49.362 64.7849C52.3679 64.0838 55.4851 66.5076 55.8425 69.5096C56.3347 72.2947 54.3445 75.201 51.5984 75.8142C48.6433 76.6092 45.3074 74.4939 44.7527 71.4881C44.0339 68.4705 46.3445 65.2615 49.362 64.7849Z" fill="#FF7D00" />
    <path d="M49.3032 17.2303C50.9868 16.7616 52.8208 17.4921 53.9204 18.8007C64.9438 38.1053 76.02 57.3866 87.059 76.6854C87.8715 78.1717 87.9399 80.0878 87.0747 81.5682C86.3149 82.9217 84.8364 83.912 83.2602 83.8963C61.7739 83.8944 40.2876 83.8944 18.8012 83.8963C17.3208 83.9198 15.6958 83.8143 14.4985 82.8436C13.0922 81.7753 12.4458 79.8514 12.8754 78.1444C13.0864 76.9921 13.7504 76.0116 14.3169 75.0116C24.9594 56.4178 35.5942 37.8182 46.2368 19.2264C46.9692 18.2284 48.1333 17.5799 49.3032 17.2303ZM46.0766 36.035C44.9067 37.3866 44.559 39.2674 44.7192 41.0057C45.4184 48.4608 48.27 55.576 48.5356 63.0858C49.7251 63.1112 50.9126 63.0585 52.102 63.0272C52.2876 60.4374 52.5454 57.8495 53.0727 55.3026C53.979 51.0038 55.1665 46.7616 55.8501 42.4159C56.0161 41.1776 56.1723 39.9042 55.9126 38.6678C55.6508 37.2909 54.8461 36.0194 53.6997 35.2108C51.4516 33.5155 47.8872 33.8456 46.0766 36.035ZM49.3618 64.785C46.3442 65.2616 44.0337 68.4706 44.7524 71.4881C45.3071 74.494 48.643 76.6092 51.5981 75.8143C54.3442 75.201 56.3344 72.2948 55.8422 69.5096C55.4848 66.5077 52.3676 64.0839 49.3618 64.785Z" fill="#F9F9F9" />
  </svg>
);
